// src/theme/ThemeProvider.js
// Provee el objeto de tema (tokens) a los componentes primitivos vía contexto.
// Uso: envolver una pantalla migrada en <ThemeProvider mode="dark"> (tablet) o
// mode="light" (escritorio). Los primitivos leen el tema con useTheme().
// Default "dark". No hay provider global → las pantallas no migradas no se ven afectadas.

import React, { createContext, useContext } from "react";
import { getTheme } from "./tokens";

const ThemeCtx = createContext(getTheme("dark"));

export function ThemeProvider({ mode = "dark", children }) {
  return <ThemeCtx.Provider value={getTheme(mode)}>{children}</ThemeCtx.Provider>;
}

export function useTheme() {
  return useContext(ThemeCtx);
}
